(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["add_collection-list"] && !Shopify.designMode) return;
  try {
    
  // document.addEventListener('DOMContentLoaded', function () {
  //   var sliderEl = document.querySelector('.product-slider');

  //   if (sliderEl) {
  //     new Swiper(sliderEl, {
  //       loop: false,
  //       slidesPerView: 2.2,
  //       spaceBetween: 16,
  //       // grabCursor: true,
  //       breakpoints: {
  //         768: {
  //           slidesPerView: 3.2,
  //           spaceBetween: 24,
  //         },
  //         1024: {
  //           slidesPerView: 4.5,
  //           spaceBetween: 15,
  //         }
  //       }
  //     });
  //   }
  // });

  } catch(e) { console.error(e); }
})();
})();
